import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import LinkWithPopover from './link-with-popover';
import Purchase from '../lib/purchase';
import { truncate } from '../lib/functions';

class PurchaseSummaryDetails extends Component {
  renderPurchaseDetails() {
    const { name, description } = this.props;

    if (!description) return null;

    return (
      <LinkWithPopover
        name="product-description"
        text={
          <FormattedMessage
            id="purchaseSummaryDetails.moreInfo"
            defaultMessage="More info"
          />
        }
        placement="left"
      >
        <div className="product-description mt-3">
          <h4>{name}</h4>
          <p className="small-print mb-3"
            dangerouslySetInnerHTML={{
              __html: Purchase.renderProductDescription(truncate(description, 600))
            }}/>
        </div>
      </LinkWithPopover>
    );
  }

  render() {
    const productName = this.props.name;

    return (
      <div className="purchase-summary-details">
        <h4 className="mt-3 mb-0" title={productName}>
          {truncate(productName, 50)}
        </h4>
        {this.renderPurchaseDetails()}
      </div>
    );
  }
}

export default PurchaseSummaryDetails;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-summary-details.js